import { Route } from "@websim/core/src/route";

export function makeBaseUrl(data: {
  isTopLevelFrame: boolean;
  contentOrigin: string;
  hostOrigin: string;
  project_id?: string;
  route: Route;
}) {
  if (data.isTopLevelFrame) {
    return data.contentOrigin;
  }
  if (data.project_id) {
    return `${data.hostOrigin}${getBasePath(data.route)}`;
  }
  // Unexpected case:
  return "https://websim.com";
}

export function getBasePath(route: Route) {
  if (route.type === "slug") {
    return `/@${route.username}/${route.slug}`;
  }
  if (route.type === "profile") {
    return `/@${route.username}`;
  }
  if (route.type === "site") {
    return `/c/${route.id}`;
  }
  if (route.type === "home") {
    return "/";
  }
  if (route.type === "project") {
    return `/p/${route.id}`;
  }
  if (route.type === "fyp") {
    return "/fyp";
  }
  if (route.type === "not-found") {
    return "/not-found";
  }
  return "/";
}
